import {
  AreaChart, Area, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell, Legend,
} from "recharts";
import { compactINR } from "@/components/tools/kit";

const axis = { fontSize: 11, fill: "#8A9790" };

export const GrowthArea = ({ data, keys, height = 260 }) => (
  <div style={{ height }} data-testid="growth-chart">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <defs>
          {keys.map((k) => (
            <linearGradient key={k.key} id={`g-${k.key}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={k.color} stopOpacity={0.5} />
              <stop offset="100%" stopColor={k.color} stopOpacity={0.04} />
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#EFEBE2" vertical={false} />
        <XAxis dataKey="year" tick={axis} tickLine={false} axisLine={false} />
        <YAxis tick={axis} tickLine={false} axisLine={false} tickFormatter={(v) => compactINR(v)} width={70} />
        <Tooltip formatter={(v, n) => [compactINR(v), n]} labelFormatter={(l) => `Year ${l}`}
          contentStyle={{ borderRadius: 12, border: "1px solid #E8E3D9", fontSize: 12 }} />
        {keys.map((k) => (
          <Area key={k.key} type="monotone" dataKey={k.key} name={k.name} stroke={k.color}
            strokeWidth={2.5} fill={`url(#g-${k.key})`} />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export const CompareLines = ({ data, keys, height = 280 }) => (
  <div style={{ height }} data-testid="compare-chart">
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#EFEBE2" vertical={false} />
        <XAxis dataKey="year" tick={axis} tickLine={false} axisLine={false} />
        <YAxis tick={axis} tickLine={false} axisLine={false} tickFormatter={(v) => compactINR(v)} width={70} />
        <Tooltip formatter={(v, n) => [compactINR(v), n]} labelFormatter={(l) => `Year ${l}`}
          contentStyle={{ borderRadius: 12, border: "1px solid #E8E3D9", fontSize: 12 }} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        {keys.map((k) => (
          <Line key={k.key} type="monotone" dataKey={k.key} name={k.name} stroke={k.color} strokeWidth={3} dot={false} />
        ))}
      </LineChart>
    </ResponsiveContainer>
  </div>
);

export const SplitDonut = ({ segments, height = 240 }) => (
  <div style={{ height }} data-testid="split-donut">
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie data={segments} dataKey="value" nameKey="name" innerRadius="58%" outerRadius="85%" paddingAngle={2} stroke="none">
          {segments.map((s, i) => <Cell key={i} fill={s.color} />)}
        </Pie>
        <Tooltip formatter={(v, n) => [compactINR(v), n]}
          contentStyle={{ borderRadius: 12, border: "1px solid #E8E3D9", fontSize: 12 }} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
      </PieChart>
    </ResponsiveContainer>
  </div>
);
